module.exports = __webpack_public_path__ + "static/media/S (89).63d2f145.jpg";